var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.showNavBar)?_c('NavBar',{key:_vm.navBarKey}):_vm._e(),_c('router-view',{key:_vm.componentKey})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }